// Canonical list of the main-menu services.
//
// One entry per row in dbo.service_categories. `code` is the join key with the
// backend; `menuId` matches the id used by the AuthHeader menu data; `routes`
// lists every SPA path the category owns, so a disabled category can have its
// routes unregistered as well as its menu entry greyed out.
//
// Telecom deliberately owns the company/topup routes: it is the fallback
// service and is not expected to be switched off.

export const SERVICE_CATEGORIES = [
  {
    code: "telecom",
    menuId: 1,
    labelKey: "Telecom",
    routes: ["/", "/internet", "/company"],
  },
  {
    code: "insurance",
    menuId: 3,
    labelKey: "Insurance",
    routes: ["/insurance"],
  },
  {
    code: "gaming",
    menuId: 4,
    labelKey: "Gaming",
    routes: ["/gaming", "/jwaker"],
  },
  {
    code: "cards",
    menuId: 5,
    labelKey: "Gift Cards",
    routes: ["/cards", "/print-card"],
  },
  {
    code: "bills",
    menuId: 11,
    labelKey: "Bills",
    routes: ["/pay_bills", "/bills"],
  },
  { code: "esim", menuId: 12, labelKey: "Esim", routes: ["/esim"] },
  { code: "icloud", menuId: 13, labelKey: "Icloud", routes: ["/icloud"] },
  { code: "wallet", menuId: 14, labelKey: "wallet", routes: ["/wallet"] },
  { code: "sms", menuId: 15, labelKey: "SMS", routes: ["/sms"] },
  { code: "newsim", menuId: 16, labelKey: "newSim", routes: ["/newSim"] },
  { code: "tiktok", menuId: 18, labelKey: "tiktok", routes: ["/tiktok"] },
];

const CODE_BY_MENU_ID = SERVICE_CATEGORIES.reduce((acc, category) => {
  acc[category.menuId] = category.code;
  return acc;
}, {});

// Longest route first, so "/pay_bills/jawwal" matches the bills prefix before
// a shorter unrelated one could.
const ROUTE_INDEX = SERVICE_CATEGORIES.reduce((acc, category) => {
  category.routes.forEach((route) => acc.push({ route, code: category.code }));
  return acc;
}, []).sort((a, b) => b.route.length - a.route.length);

export const categoryCodeForMenuId = (menuId) => CODE_BY_MENU_ID[menuId];

// Which category owns an SPA path. "/" only ever matches itself, otherwise it
// would claim every route in the app.
export const categoryCodeForRoute = (path) => {
  if (!path) return undefined;
  const match = ROUTE_INDEX.find(({ route }) =>
    route === "/" ? path === "/" : path === route || path.startsWith(`${route}/`)
  );
  return match && match.code;
};

// An unknown code is treated as enabled: a category missing from the API
// response must never blank out a working part of the menu.
export const isCategoryEnabled = (categories, code) => {
  if (!code) return true;
  if (!categories || categories[code] === undefined) return true;
  return Boolean(categories[code]);
};
